/* unplugin-vue-components disabled */import { render } from "./home.vue?vue&type=template&id=4e2b1b3e&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=4e2b1b3e&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\hello_world\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2b1b3e"]])

export default __exports__